import useApiRequest from 'api/useApiRequest';
import {
  fetchCrmInteractionDateHistogram,
  fetchCrmInteractionQuery,
  fetchCrmInteraction,
  createCrmInteraction,
  updateCrmInteraction,
  deleteCrmInteractions,
} from 'api/services/crmInteractionService';

const useCrmInteraction = () => {
  const { request } = useApiRequest();

  const getCrmInteractionDateHistogram = async (params) => {
    const { data } = await fetchCrmInteractionDateHistogram(request, params);
    return data;
  };

  const queryCrmInteractions = async (params) => {
    const { data } = await fetchCrmInteractionQuery(request, params);
    return data;
  };

  const getCrmInteraction = async (params) => {
    const { data } = await fetchCrmInteraction(request, params);
    return data;
  };

  const addCrmInteraction = async (params) => {
    const { data } = await createCrmInteraction(request, params);
    return data;
  };

  const saveCrmInteraction = async (params) => {
    const { data } = await updateCrmInteraction(request, params);
    return data;
  };

  const removeCrmInteractions = async (params) => {
    const { data } = await deleteCrmInteractions(request, params);
    return data;
  };

  return {
    getCrmInteractionDateHistogram,
    queryCrmInteractions,
    getCrmInteraction,
    addCrmInteraction,
    saveCrmInteraction,
    removeCrmInteractions,
  };
};

export default useCrmInteraction;
